import { inject, ref, computed, onMounted, onBeforeUnmount } from "vue";
import { u as useComponentUuid } from "../useComponentUuid-fe318ec5.mjs";
import { F as FormServiceKey } from "./consts-bc55152e.mjs";
const useFormChild = (createContext) => {
  const formContext = inject(FormServiceKey, null);
  if (!formContext) {
    return {
      doShowError: ref(true),
      doShowErrorMessages: ref(true),
      doShowLoading: ref(true)
    };
  }
  const context = computed(createContext);
  const uid = useComponentUuid();
  onMounted(() => {
    formContext.registerField(uid, context);
  });
  onBeforeUnmount(() => {
    formContext.unregisterField(uid);
  });
  return {
    doShowError: formContext.doShowError,
    doShowErrorMessages: formContext.doShowErrorMessages,
    doShowLoading: formContext.doShowLoading
  };
};
export {
  useFormChild as u
};
//# sourceMappingURL=useFormChild-28e78c0e.mjs.map
